module.exports = __webpack_public_path__ + "static/media/238.cc3bc786.webp";